// 使用了 redis 缓存后，出现一个问题，用户直接输入 www.bigo.tv访问官网
// 页面不会自动根据用户浏览器语言重定向到对应路径
// 所以在 client side 做个判断，如果页面链接上没有cookies里的 lang code
// 则做一次带语言码的链接重定向
// eg: https://www.bigo.tv/show -> https://www.bigo.tv/cn/show
// 但是似乎是个偶现问题，大部分情况下是会做 302 临时重定向的

export default ({ app: { i18n } }) => {
  const defaultLocale = i18n.defaultLocale;
  const langCookie = i18n.getLocaleCookie();
  const { pathname, host, href } = window.location;
  const isBigoTv = host === 'www.bigo.tv' || host === 'ta-www.bigo.tv';

  if (
    langCookie &&
    langCookie !== defaultLocale &&
    !pathname.includes(langCookie) &&
    isBigoTv
  ) {
    console.log(`【switch lang url】${langCookie}`);
    const newUrl = href.replace(host, `${host}/${langCookie}`);
    console.log(`prev url: ${href}, new url: ${newUrl}`);
    window.location.replace(newUrl);
  }
};
